import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const BomImportRoute: RouteType = {
  name: "BOM Import",
  path: "/purchasing/bom-import",
  layout: "/app",
  group: "Purchasing",
  requiresAuth: true,
  requiresPermission: false,
  hidden: true,
  viewportCard: {
    header: {
      title: "BOM Import & Material Matching",
      component: () => import("./BomImportHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./BomImportBody"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      const materialsStore = rootStore.materialsStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const billOfMaterialsStore = rootStore.billOfMaterialsStore as ServiceStore;

      if (materialsStore) {
        await materialsStore.find({ query: { $limit: 500 } });
      }

      if (productsStore) {
        await productsStore.find();
      }

      if (billOfMaterialsStore) {
        await billOfMaterialsStore.find({ query: { $limit: 100 } });
      }

      return true;
    } catch (error) {
      console.error("Failed to load data for BOM import:", error);
      return true;
    }
  },
  onExit: ({ rootStore }: any) => {
    const viewStore = (rootStore as any).bomImportViewStore;
    if (viewStore) {
      viewStore.reset();
    }
  },
};

export default BomImportRoute;